import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { createRootRoute, Outlet, useRouterState } from '@tanstack/react-router';
import { Sidebar } from '../components/layout/sidebar';
import { Topbar } from '../components/layout/topbar';
import { Toaster } from '../components/ui/toaster';
import { ErrorBoundary } from '../components/common/error-boundary';

function RootLayout(): JSX.Element {
  // Re-key the boundary on navigation so an error on one route doesn't persist
  // after the user moves to another.
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <div className="flex min-h-screen w-full">
      <Sidebar />
      <div className="flex flex-1 flex-col">
        <Topbar />
        <main className="flex-1 p-4 md:p-6">
          <QueryErrorResetBoundary>
            {({ reset }) => (
              <ErrorBoundary key={pathname} onReset={reset}>
                <Outlet />
              </ErrorBoundary>
            )}
          </QueryErrorResetBoundary>
        </main>
      </div>
      <Toaster />
    </div>
  );
}

export const Route = createRootRoute({ component: RootLayout });
